import { Client } from 'urql';
import { CustomerPagePath } from 'views/constants/enums/pageTitle';
import { IconName } from 'views/utils/handleIcon';
import { GetOmegaFsSsoParamDocument, LogoutDocument, OmegaFsSsoParam } from 'views/utils/graphql/graphql';
import { submitForm } from './submitForm';

export type MenuButtonProps = {
  buttonType?: MenuButtonType;
  to: string;
  action?: Function;
  className?: string;
  iconName: IconName;
  label: string;
  label2?: string;
};

export enum MenuButtonType {
  NavLink,
  Button,
}

export const middleMenuData: MenuButtonProps[] = [
  { to: CustomerPagePath.Home, iconName: IconName.Home, label: 'ホーム' },
  {
    to: CustomerPagePath.ProductList,
    iconName: IconName.List,
    label: '募集銘柄一覧',
  },
  {
    to: CustomerPagePath.OrderStatus,
    iconName: IconName.Repeat,
    label: '申込履歴',
  },
  {
    to: CustomerPagePath.AccountAsset,
    iconName: IconName.ChartLine,
    label: '資産管理',
  },
  {
    to: CustomerPagePath.AccountTransactionHistory,
    iconName: IconName.Repeat,
    label: '入出金履歴',
  },
  { to: CustomerPagePath.Notice, iconName: IconName.Alert, label: 'お知らせ' },
  {
    buttonType: MenuButtonType.Button,
    to: process.env.REACT_APP_DOCUMENT_GRANT!,
    iconName: IconName.Document,
    label: '交付書面',
    label2: '(電子交付専用)',
    action: async (client: Client, to: string, showError: (message: string) => void) => {
      const ret = await client.query(GetOmegaFsSsoParamDocument, {}, { requestPolicy: 'network-only' });
      console.log(ret.error);
      if (ret.error) {
        showError('エラーが発生しました。しばらくしてから再度お試しください。');
        return;
      }
      const param: OmegaFsSsoParam = ret.data?.GetOmegaFsSsoParam;
      // form作ってpostする(別タブ開く)
      submitForm('post', to, 'main_frm', {
        KAIIN: param.Kaiin,
        BUTEN: param.Buten,
        USER_CD: param.UserCd,
        SHORI_YMD: param.ShoriYMD,
        SHORI_HMS: param.ShoriHMS,
        GAMEN_ID: param.GamenID,
        GAMEN_PARM: param.GamenParm,
        MENU_DISP_FLG: param.MenuDispFlg,
        __RESULT_KENSHO: param.ResultKensho,
      });
    },
  },
  {
    to: CustomerPagePath.AccountInfo,
    iconName: IconName.Setting,
    label: '登録情報',
  },
  {
    to: CustomerPagePath.TransferDistination,
    iconName: IconName.Bank,
    label: '振込先口座',
  },
  {
    to: CustomerPagePath.SecuritySetting,
    iconName: IconName.Setting,
    label: 'パスワード・パスキー設定',
  },
];

export const bottomMenuData: MenuButtonProps[] = [
  // { to: CustomerPagePath.Login, iconName: IconName.SignOut, label: "ログイン" },
  {
    to: CustomerPagePath.Contact,
    iconName: IconName.Help,
    label: 'お問い合わせ',
  },
  {
    to: CustomerPagePath.Login,
    action: async (client: Client) => {
      await client.mutation(LogoutDocument, {}, { requestPolicy: 'network-only' });

      sessionStorage.removeItem('token');
      sessionStorage.removeItem('last_4_digits');
    },
    iconName: IconName.SignOut,
    label: 'ログアウト',
  },
];

export const bottomMenuDataPath: MenuButtonProps[] = [
  {
    to: CustomerPagePath.ReissuePassword,
    iconName: IconName.SignOut,
    label: 'パスワード再発行',
  },
  {
    to: CustomerPagePath.SendSMS,
    iconName: IconName.SignOut,
    label: '2段階認証',
  },
  {
    to: CustomerPagePath.Contact,
    iconName: IconName.Help,
    label: 'お問い合わせ',
  },
  {
    to: CustomerPagePath.Login,
    iconName: IconName.SignOut,
    label: '',
  },
];

const menuData: MenuButtonProps[] = middleMenuData.concat(bottomMenuDataPath);

export const findPathName = (path: string) => {
  return menuData.find((pathData) => pathData.to === path)?.label || '';
};
